import React, { Component } from 'react';

class Pagination extends Component {


    stepFunc = () => {
        switch(this.props.step) {
            case 1:
                if (this.props.checkTreatment()) {
                    this.props.setStep(this.props.step + 1);
                    this.props.getDates();
                }
                break;
            case 2:
                if (this.props.checkDate()) {
                    this.props.setStep(this.props.step + 1);
                    this.props.getTimes();
                }
                break;
            case 3:
                if (this.props.checkTime()) {
                    this.props.setStep(this.props.step + 1);
                }
                break;
            case 4:
                if (this.props.checkAck()) {
                    this.props.setPage('result');
                    this.props.finish()
                }
                break;
            default:
        }
    }

    content() {
        let content;
        switch(this.props.step) {
            case 1:
                content =   <div className="column pagination-btns">
                                <button 
                                    className="button is-danger is-medium is-pulled-right"
                                    onClick={this.stepFunc}>
                                    <span className="pagination-text">
                                        Stap 2
                                    </span>
                                    <span className="icon">
                                        <i className="fas fa-chevron-right"></i>
                                    </span>
                                </button>
                            </div>
                break;
            case 2:
            case 3:
                content =   <div className="column pagination-btns">
                                <button 
                                    className="button is-danger is-medium is-pulled-left"
                                    onClick={() => this.props.setStep(this.props.step - 1)}>
                                    <span className="icon">
                                        <i className="fas fa-chevron-left"></i>
                                    </span>
                                    <span className="pagination-text">{"Stap " + (this.props.step - 1)}</span>
                                </button>
                                <button 
                                    className="button is-danger is-medium is-pulled-right"
                                    onClick={this.stepFunc}>
                                    <span className="pagination-text">{"Stap " + (this.props.step + 1)}</span>
                                    <span className="icon">
                                        <i className="fas fa-chevron-right"></i>
                                    </span>
                                </button>
                            </div>
                break;
            case 4:
                content =   <div className="column pagination-btns">
                                <button 
                                    className="button is-danger is-medium is-pulled-left"
                                    onClick={() => this.props.setStep(this.props.step - 1)}>
                                    <span className="icon">
                                        <i className="fas fa-chevron-left"></i>
                                    </span>
                                    <span className="pagination-text">{"Stap " + (this.props.step - 1)}</span>
                                </button>
                                <button className="button is-danger is-medium is-pulled-right">
                                    <span className="pagination-text" onClick={this.stepFunc}>
                                        Bevestigen
                                    </span>
                                    <span className="icon">
                                        <i className="fas fa-chevron-right"></i>
                                    </span>
                                </button>
                            </div>
                break;
            default:
        }
        return content;
    }

    render() {
        return (
            <div className="is-mobile columns is-centered" style={{width: "100%"}}>
                {this.content()}
            </div>
        );
    }
}

export default Pagination;